export default __webpack_public_path__ + "static/media/icon-arrowDown.d7ff9604.svg";